import { sendMessageToAndroid } from '@src/bridge/sender';
import { generateUID } from '@src/bridge/handlers/share';
import { EWebViewEvents, IWebViewEvent } from '@src/bridge/types';
import axios from 'axios';

class ErrorInspector {
  private static instance: ErrorInspector;
  private isInitialized = false;

  public static getInstance(): ErrorInspector {
    if (!ErrorInspector.instance) {
      ErrorInspector.instance = new ErrorInspector();
    }
    return ErrorInspector.instance;
  }

  public initialize(): void {
    if (this.isInitialized) return;
    this.setupBasicErrorHandling();
    this.isInitialized = true;
  }

  private setupBasicErrorHandling(): void {
    // Handle fetch errors
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);
        if (!response.ok && response.status >= 500) {
          this.handleError(new Error(`HTTP ${response.status}: ${response.statusText}`));
        }
        return response;
      } catch (error) {
        if (error instanceof Error && error.message.includes('HTTP 5')) {
          this.handleError(error);
        }
        throw error;
      }
    };

    // Handle axios errors
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status >= 500) {
          this.handleError(new Error(`HTTP ${error.response.status}: ${error.response.statusText}`));
        } else if (error.code === 'NETWORK_ERROR' || error.code === 'ERR_NETWORK') {
          this.handleError(new Error('Network error occurred'));
        }
        return Promise.reject(error);
      }
    );
  }

  private handleError(error: Error): void {
    this.sendErrorToBridge();
  }

  private sendErrorToBridge(): void {
    try {
      const message: IWebViewEvent = {
        type: EWebViewEvents.SERVER_ERROR,
        payload: {
          id: generateUID(),
        },
      };
      sendMessageToAndroid(message);
    } catch (bridgeError) {}
  }

  public reportError(error: Error): void {
    this.handleError(error);
  }
}

export default ErrorInspector.getInstance();
